import * as React from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import SendMessagePreviewModal from './SendMessagePreviewModal';

export default function DocumentButton({ name, disabled, handleDownload, handleShow, handleSend, notificationType = 'SAGR' }) {
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPreviewModal = () => setOpenPreviewModal(true);
  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  return (
    <div>
      <Button
        id="basic-button"
        disabled={disabled}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        onClick={handleClick}
      >
        {name}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={handleDownload}>
          <ListItemIcon>
            <FileDownloadIcon />
          </ListItemIcon>
          <ListItemText>
              Pobierz
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleShow}>
          <ListItemIcon>
            <RemoveRedEyeIcon />
          </ListItemIcon>
          <ListItemText>
              Zobacz
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleOpenPreviewModal}>
          <ListItemIcon>
            <ForwardToInboxIcon />
          </ListItemIcon>
          <ListItemText>
              Wyślij
          </ListItemText>
        </MenuItem>
      </Menu>
      {openPreviewModal
        ? <SendMessagePreviewModal
          handleSend={data => {
            handleSend(data);
            handleClosePreviewModal();
          }}
          handleClose={handleClosePreviewModal}
          fileNames={[name]}
          type={notificationType}/>
        : null}
    </div>
  );
};
